import { AnalyticsTimelineData, TimelineItem } from "../Api/StatsTimelineApi";
import moment from "moment";
import ClickStat from "./ClickStat";


export interface ClickChartDataProvider {
    getChartData(): ClickStat[]

    /** Sums up the data from all entries into into a single data object */
    getChartTotal(): ClickStat,
}

export default class TimelineItemCollection implements ClickChartDataProvider {
    public readonly data: ClickStat[];
    public interval: Readonly<AnalyticsTimelineData["interval"]> = "hour";
    public timezone: Readonly<AnalyticsTimelineData["timezone"]> = "0";

    constructor(
        items: TimelineItem[] = [],
        interval: AnalyticsTimelineData["interval"] = "hour",
        timezone = "0",
    ) {
        this.interval = interval;
        this.timezone = timezone;
        this.data = Object.values(items).map((i: TimelineItem) => new ClickStat(
            moment(i.datetime).format(), // Name
            i.human, // human
            i.unique, // unique
            i.total - i.human, // Bots
            i.total, // total
        ));
    };

    public getChartTotal(): ClickStat {
        return this.data.reduce((carry: ClickStat, clickstat: ClickStat): ClickStat => {
            carry.total += clickstat.total;
            carry.human += clickstat.human
            carry.unique += clickstat.unique;
            carry.bots += clickstat.bots;
            return carry;
        }, new ClickStat("Timeline Totals"));
    }

    /**
    * Converts the collection into the array format expected by the tinyurl chart components
    */
    public getChartData(): ClickStat[] {
        return this.data
    }
}

